
import React from 'react';
import {Typography, Link } from '@mui/material';
import { APP_VERSION } from '../../config/app-version';

export default function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center" sx={{ pt: 2, pb: 1 }}>
      {'Copyright © '}
      <Link color="inherit" href="https://elsmereeducation.com/">
        Human Capital Education
      </Link>{' '}
      {new Date().getFullYear()}
      {' | version '}
      {APP_VERSION}

    </Typography>
  );
}


